import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { InventoryDetail } from '@/types/inventory';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/**
 * `sku`, not `product_id`: kitchensink only rejects kit products when it resolves the product from the SKU. A blank cost
 * is omitted, so the column's default (`0`) applies.
 */
export type InventoryDetailCreate = { sku: string; warehouse_id: number; quantity: number; tracking: 'basic'; cost?: string };

/**
 * When the product already has a row for the warehouse, kitchensink updates that row instead (an upsert). `num_results`
 * tells the two apart: 1 means a row was inserted, 2 or 0 that an existing row was updated or left as it was, and then
 * the result's `id` is not that row's.
 */
export const createInventoryDetail = async (
  scope: RequestScope,
  { data }: { data: InventoryDetailCreate },
  options: WriteRequestOptions
): Promise<EndpointResponse<InventoryDetail>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<InventoryDetail>>('inventory_detail', data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
